<template>
  <div>
    <!-- Clear Selected search criteria,  Selected Search Criteria-->
    <vx-card class="mb-8">
      <div class="card-title more-card-title flex justify-between items-center">
        <div class="flex items-center flex-wrap">
          <h2 class="w-auto mb-2">{{ LabelConstant.headingLabelSelectedCriteria }}</h2>
          <p class="table-data-entries-details text-left mb-2 w100">
            Total Known Customers and Associates: <span>{{ totalKnownCustomer | tableRecordNumberFormatter }}</span>
          </p>
        </div>
        <div class="flex items-center flex-wrap">
        <vs-button
          color="success"
          class="sm:mt-0 mt-2 mr-2"
          icon-pack="feather"
          type="filled"
          @click="isUploadPopup = true"
        >Upload List</vs-button>
        <!-- Clear Selected search criteria and known customer -->
        <vs-button
          color="grey"
          type="border"
          class="grey-btn sm:mt-0 mt-2"
          icon-pack="feather"
          icon="icon-refresh-ccw"
          @click="clearSearchCriteria()"
        >{{ LabelConstant.buttonLabelClearSearchCriteria }}</vs-button>
      </div>
      </div>
      <!-- Selected Search Criteria -->
      <div class="vx-row find-people">
        <div class="vx-col w-full">
          <input-tag v-model="tags" @input="testUpdateSelectedTags"></input-tag>
        </div>
      </div>
    </vx-card>
    
    <!-- Search Criteria Filter, known customer Table -->
    <vx-card>
      <div class="vx-row find-people search-lead">
        <!-- Search Criteria Filter -->
        <div class="vx-col xl:w-1/4 col-cus-12 mb-8 w-full">
          <div class="px-0 search-filters">
            <div slot="header" class="filter-header pl-0">{{ LabelConstant.headingLabelSearchCriteria }}</div>       
            <!-- Personal criteria  --> 
            <div class="filter-card">   
              <div class="filter-list">
                <vs-checkbox v-model="showEmailAddress" @click="emailAddress=null">Email Address</vs-checkbox>
                <div v-if="showEmailAddress">
                  <vs-input
                    v-model="emailAddress"
                    class="w-full"
                    placeholder="Type email address here"
                  />
                </div>
                <vs-checkbox v-model="showHashedAddress" @click="hashedAddress=null">Hashed Address</vs-checkbox>
                <div v-if="showHashedAddress">
                  <vs-input
                    v-model="hashedAddress"
                    class="w-full"
                    placeholder="Type hashed address here"
                  />
                </div>
                <vs-checkbox v-model="showNameText" @click="firstName = null,lastName=null">{{ LabelConstant.inputLabelName }}</vs-checkbox>
                <div v-if="showNameText">
                  <vs-input
                    v-model="firstName"
                    class="mb-2 w-full"
                    placeholder="Type first name here"
                  />
                  <vs-input
                    v-model="lastName"
                    class="w-full"
                    placeholder="Type last name here"
                  />
                </div>
                <div>
                  <vs-checkbox v-model="showDatePicker" @click="showDatePicker ? removeDate() : populateData()">Date Added</vs-checkbox>
                  <date-range-picker
                    v-show="showDatePicker"
                    ref="lastVisitedDynamicType"
                    class="float-unset"
                    :fromDateValue="fromDate"
                    :toDateValue="toDate"
                    @inputFromDate="(newFromDate) => {fromDate = newFromDate}"
                    @inputToDate="(newToDate) => {toDate = newToDate}"
                  ></date-range-picker>
                </div>
              </div>
            </div>  
          </div>
          <!-- buttons -->
          <div class="pt-5 mt-5 flex">
            <vs-button
              :title="LabelConstant.buttonLabelSearch"
              color="primary"
              type="filled"
              class="mr-1 px-5"
              @click="searchKnownConstomer()"
            >{{ LabelConstant.buttonLabelSearch }}</vs-button>
          </div>
        </div>
        <!-- searched-known customer table-->
        <div class="vx-col xl:w-3/4 col-cus-12 mb-8 w-full border-left">
          <div>
            <vs-navbar class="nabarx mb-8 table-nav">
              <div slot="title">
                <vs-navbar-title> Search Your Known Customers and Associates </vs-navbar-title>
              </div>
              <vs-navbar-item index="0" class="search-associate">
                <dropdown-menu class="dropdown-export">
                  <button slot="trigger" class="dropdown-export-btn">
                    Actions
                    <i class="vs-icon notranslate icon-scale material-icons null">expand_more</i>
                  </button>
                  <ul slot="body" >
                    <li @click="isPopup = true"> Add Known Customer </li>
                    <li @click="isUploadPopup = true"> Upload List </li>
                    <li @click="resetConfirmPopup = true"> Reset List </li>
                    <li @click="selectedMain.length > 0 ? deleteConfirmPopup = true : ''"> Delete Known Customers </li>
                  </ul>
                </dropdown-menu>
              </vs-navbar-item>
              <v-select
                class="ml-2 show-tbl-data"
                label="value"
                :options="showEntriesOptions"
                :reduce="(option) => option.value"
                :clearable="false"
                v-model="recordPerMainPage"
                @input="searchKnownConstomerPerPage()"
              />
            </vs-navbar>
          </div>
          <!-- Find known customer table-->
          <div class="common-table pt-0">
            <!-- table -->
            <vs-table multiple v-model="selectedMain" :data="knownCustomrList" class="ecommerce-search-table">
              <template slot="thead">
                <vs-th>Email Address</vs-th>
                <vs-th>First Name</vs-th>
                <vs-th>Last Name</vs-th>
                <vs-th>Date Added</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].EmailAddress">
                    <a class="cursor-pointer" @click="isPopup = true, editableKnownCustomer = data[indextr], addeditableKnownCustomerEmail = data[indextr].EmailAddress, firstNameKnownCustomer=data[indextr].FirstName, lastNameKnownCustomer = data[indextr].LastName">{{ data[indextr].EmailAddress }}</a> 
                  </vs-td>
                  <vs-td :data="data[indextr].FirstName" width="50px">
                    {{ data[indextr].FirstName }}
                  </vs-td>
                  <vs-td :data="data[indextr].LastName" width="50px">
                    {{ data[indextr].LastName }}
                  </vs-td>
                  <vs-td :data="data[indextr].DateAdded">
                    {{ data[indextr].DateAdded }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <!-- Total known customer and Pagination -->
            <div class="vx-row clear-both">
              <div class="vx-col w-full mt-4 lg:w-full">
                <div class="flex items-center justify-between paginate-row flex-wrap">
                  <p class="table-data-entries-details">
                    Known Customers and Associates Found: <span>{{ totalSearchedKnownCustomer | tableRecordNumberFormatter }}</span>
                  </p>
                  <b-pagination
                    pills
                    size="sm"
                    class="pr-3 bootstrap-pagination"
                    v-model="currentPage"
                    :total-rows="totalKnownCustomer"
                    :per-page="recordPerMainPage"
                    :limit="1"
                    prev-text="< Prev"
                    next-text="Next >"
                    :hide-goto-end-buttons="true"
                    @change="searchKnownConstomerPerPage()"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <!-- Delete -->
    <vs-popup class="transaction-popup" :active.sync="deleteConfirmPopup">             
        <div class="transaction-details">
            <div class="popup-icon">
                <img src="../../../assets/images/trash.svg">
            </div>
            <h2>Delete</h2>
            <p>Are you sure you wish to delete selected customer(s)?</p>
            <div class="float-left mt-6 w-full text-center">             
                <vs-button @click="deleteSuppression()" color="success" class="mt-0 sm:w-auto w-full" type="filled">Delete</vs-button>
                <vs-button @click="deleteConfirmPopup = false, selectedMain=[]" color="grey" type="border" class="grey-btn sm:ml-4  ml-0 mt-2 sm:mt-0 sm:w-auto w-full">{{ LabelConstant.buttonLabelCancel }}</vs-button>            
            </div>
        </div>            
    </vs-popup>
    <!-- Add -->
    <vs-popup class="" :title="editableKnownCustomer ? 'Update Known Customer' : 'Add Known Customer'" :active.sync="isPopup">
      <template>
          <div class="vx-row">
            <div class="vx-col mb-2 w-full">
              <p class="w-full float-left"> Email or SHA256 Hash <spna class="text-danger">(Required)</spna> </p>
              <div class="vx-row align-center">
                <div class="vx-col mb-0 w-full">
                  <vs-input class="w-full mb-4" type="text" v-model="addeditableKnownCustomerEmail"></vs-input>
                </div>
              </div>
              <p class="w-full float-left"> First Name </p>
              <div class="vx-row align-center">
                <div class="vx-col mb-0 w-full">
                  <vs-input class="w-full mb-4" type="text" v-model="firstNameKnownCustomer"></vs-input>
                </div>
              </div>
              <p class="w-full float-left"> Last Name </p>
              <div class="vx-row align-center">
                <div class="vx-col mb-0 w-full">
                  <vs-input class="w-full mb-4" type="text" v-model="lastNameKnownCustomer"></vs-input>
                </div>
              </div>
            </div>
          </div>
      </template>
      <div class="text-right mt-6 mb-8">
        <vs-button color="danger" type="filled" class="mr-2" v-if="editableKnownCustomer" @click="deleteConfirmPopup = true"> Delete </vs-button>
        <vs-button @click="!editableKnownCustomer ? addToKnownCustomers() : updateKnownCustomers()" color="primary" type="filled" class="mr-2" :disabled="!addeditableKnownCustomerEmail"> {{ editableKnownCustomer ? 'Update Customer' : 'Add Customer' }} </vs-button>
        <vs-button
          color="grey"
          type="border"
          class="grey-btn"
          @click="isPopup = false, addeditableKnownCustomerEmail = null, firstNameKnownCustomer = null, lastNameKnownCustomer = null, editableKnownCustomer = null"
        >{{ LabelConstant.buttonLabelClose }}</vs-button>
      </div>
    </vs-popup>
    <!-- Reset -->
    <vs-popup class="transaction-popup" :active.sync="resetConfirmPopup">             
        <div class="transaction-details">
            <div class="popup-icon">
                <img src="../../../assets/images/warning.svg">
            </div>
            <h2>Reset</h2>
            <p>Are you sure you want to reset your existing list?</p>
            <div class="float-left mt-6 w-full text-center">             
                <vs-button @click="resetExistingList()" color="success" class="mt-0 sm:w-auto w-full" type="filled">Reset</vs-button>
                <vs-button @click="resetConfirmPopup = false" color="grey" type="border" class="grey-btn sm:ml-4  ml-0 mt-2 sm:mt-0 sm:w-auto w-full">{{ LabelConstant.buttonLabelCancel }}</vs-button>            
            </div>
        </div>            
    </vs-popup>
    <!-- Is Overwrite Existing List -->
    <vs-popup class="transaction-popup" :active.sync="isOverwriteExistingListPopup">             
        <div class="transaction-details">
            <div class="popup-icon">
                <img src="../../../assets/images/warning.svg">
            </div>
            <h2>Overwrite Existing List</h2>
            <p>Selecting this option will overwrite your existing list. Do you wish to continue?</p>
            <div class="float-left mt-6 w-full text-center">             
                <vs-button @click="isOverwriteExistingListPopup = false" color="success" class="mt-0 sm:w-auto w-full" type="filled">Yes</vs-button>
                <vs-button @click="isOverwriteExistingListPopup = false, overwriteExistingList = !overwriteExistingList" color="grey" type="border" class="grey-btn sm:ml-4  ml-0 mt-2 sm:mt-0 sm:w-auto w-full">No</vs-button>            
            </div>
        </div>            
    </vs-popup>
    <!-- Upload -->
    <vs-popup class="popup-width" title="Upload Known Customers" :active.sync="isUploadPopup">
      <template>
          <div class="vx-row">
            <div class="vx-col mb-2 w-full">
              <div class="vx-row align-center">
                <div class="vx-col mb-3 w-full">
                  <vs-checkbox v-model="overwriteExistingList" @click="isOverwriteExistingListPopup = !overwriteExistingList"> Overwrite Existing List</vs-checkbox>
                </div>
                <div class="vx-col flex justify-between flex-wrap w-full mt-5">
                  <h5 class="text-primary" v-if="!csvFileName && !csvFileErrorMessage"></h5>
                  <span class="file-name" v-if="csvFileName">{{ csvFileName }}</span>
                  <span class="file-name text-danger" v-if="csvFileErrorMessage">{{ csvFileErrorMessage }}</span>
                  <a href="/sample-known-customer-list.csv" download class="text-danger cursor-pointer"> Download Sample CSV File</a>
                </div>
                <div class="vx-col w-full mt-5">
                  <div class="upload-img flex flex-wrap w-full">
                    <div class="upload-input">
                      <feather-icon icon="UploadCloudIcon" class="primary-c"></feather-icon>
                      <span class="file-text">Upload File</span>
                      <input type="file" ref="file" name="file" @change="loadCSV($event)"/>
                    </div>
                    <!-- <div class="vx-row ml-3 w-full">
                      <span class="text-danger text-sm" v-if="csvFileErrorMessage" >{{ csvFileErrorMessage }}</span>
                    </div> -->
                    <div class="vx-row ml-3 w-full">  
                      <span>Drag a file containing a list of known customers to upload. Maximum file size is 100,000 records.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </template>
      <div class="text-right mt-6 mb-8">
        <vs-button title="Update" color="primary" type="filled" class="mr-2" :disabled="!isImportButton" @click="uploadEmailList()">Upload</vs-button>
        <vs-button
          color="grey"
          type="border"
          class="grey-btn"
          @click="cancelUploadEmailList()"
        >{{ LabelConstant.buttonLabelCancel }}</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import InputTag from "vue-input-tag";
import vSelect from "vue-select";
import { BPagination } from "bootstrap-vue";
import DropdownMenu from "v-dropdown-menu";
import "v-dropdown-menu/dist/v-dropdown-menu.css";
import DateRangePicker from "../../../components/filter/DateRangePicker";
import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

export default {
  components: {
    InputTag,
    "v-select": vSelect,
    BPagination,
    DropdownMenu,
    DateRangePicker,
  },
  data: () => ({     
    // for store all selected search criteria
    tagsTempArr: [],

    // Data
    fromDate: "01/01/2022",
    toDate: "01/01/2022",
    fromDateTemp: "",
    toDateTemp: "",
    showDatePicker: false,

    //personal Criteria
    showNameText: false,
    firstName: null,
    lastName: null,

    showEmailAddress: false,
    emailAddress: null,

    showHashedAddress: false,
    hashedAddress: null,

    totalSearchedKnownCustomer: 0,
    
    // page
    totalKnownCustomer: 0,
    recordPerMainPage: 10,
    currentPage: 1,
    showEntriesOptions: [
      { key: 10, value: 10 },
      { key: 25, value: 25 },
      { key: 50, value: 50 },
      { key: 100, value: 100 },
    ],
    
    // known customer list for table
    knownCustomrList: [],
    searchParams: null,
    selectedMain: [],

    isPopup: false,
    editableKnownCustomer: null,
    addeditableKnownCustomerEmail: null,
    firstNameKnownCustomer: null,
    lastNameKnownCustomer: null,

    resetConfirmPopup: false,

    deleteConfirmPopup: false,

    isUploadPopup: false,
    isOverwriteExistingListPopup: false,
    overwriteExistingList: false,
    csv: null,
    isImportButton: false,
    csvFileName: null,
    csvUploadRecords: [],
    csvFileErrorMessage: null
  }),
  computed: {
    tags: {
      get: function () {
        let arr = [];
        let that = this;
        //Search Criteria Input       
        if(!arr.includes(this.fromDate) &&!arr.includes(this.toDate) && this.fromDate!="" && this.toDate!=""){
          arr.push("Date:"+this.fromDate+'-'+this.toDate);
        }
        if (!arr.includes(this.firstName) && this.firstName!=null && this.firstName!="") {
          arr.push("First Name:" + this.firstName);
        }
        if (!arr.includes(this.lastName) && this.lastName!=null && this.lastName!="") {
          arr.push("Last Name:" + this.lastName);
        }
        if (!arr.includes(this.emailAddress) && this.emailAddress!=null && this.emailAddress!="") {
          arr.push("Email:" + this.emailAddress);
        }
        if (!arr.includes(this.hashedAddress) && this.hashedAddress!=null && this.hashedAddress!="") {
          arr.push("Hashed:" + this.hashedAddress);
        }
        
        that.tagsTempArr = [];
        that.tagsTempArr = arr;
        return arr;
      },
      set: function () {},
    },
  },
  created() { 
    // this.showDatePicker = true;
    this.setFromDate();
    this.setToDate();
    setTimeout(() => {
      this.removeDate();
      this.searchKnownConstomer();
    }, 100);
  },
  mounted(){
    this.searchKnownCustomerCountTotal();
  },
  methods: {
    formattedDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss.SSS");
    },
    removeDate(){
      this.fromDateTemp = this.fromDate;
      this.toDateTemp = this.toDate;
      this.fromDate = "";
      this.toDate = "";
    },
    populateData(){
      this.fromDate = this.fromDateTemp;
      this.toDate = this.toDateTemp;
      this.fromDateTemp = "";
      this.toDateTemp = "";
    },
    // change in Selected Criteria Input
    testUpdateSelectedTags(value) {
      let keyArr = this.tagsTempArr.filter((x) => value.indexOf(x) === -1);
      let testStr = keyArr[0];

      if (testStr.includes("Date:")) {
        this.fromDate=null
        this.toDate=null
        this.setFromDate();
        this.setToDate();
      }
      if (testStr.includes("First Name:")) {
        this.firstName = null;
      }
      if (testStr.includes("Last Name:")) {
        this.lastName = null;
      }
      if (testStr.includes("Email:")) {
        this.emailAddress = null;
      }
      if (testStr.includes("Hashed:")) {
        this.hashedAddress = null;
      }
    },
    // clear search criteria
    clearSearchCriteria() {
      this.showNameText= false;
      this.showEmailAddress= false;
      this.showHashedAddress=false;
    
      this.firstName= null;
      this.lastName= null;
      this.emailAddress= null;
      this.hashedAddress = null;

    },
    // search known customer params
    searchKnownConstomerParam(){
      // Data
      let isDateLastVisitedSelected;
      if(this.fromDate == "" && this.toDate == ""){
        isDateLastVisitedSelected=false;
      }else{
        isDateLastVisitedSelected=true;
      }
      let lastVisitedDateFrom= "2000-01-01T00:00:00.000Z";
      let lastVisitedDateTo= "2000-01-01T00:00:00.000Z";
      let dateLastVisitedDynamicType=this.checkDateRanges(this.fromDate,this.toDate);
      if(dateLastVisitedDynamicType=='custom range'){
        dateLastVisitedDynamicType=null;
        lastVisitedDateFrom= this.fromDate != "" ? this.formattedDate(this.fromDate) : this.formattedDate(this.fromDateTemp);
        lastVisitedDateTo= this.toDate != "" ? this.formattedDate(this.toDate) : this.formattedDate(this.toDateTemp);
      }    

      // personal Criteria
      let isFullNameSelected = false;
      let firstNameParam=null;
      if (this.firstName){
        isFullNameSelected = true;
        firstNameParam=this.firstName
      }

      let lastNameParam=null;
      if (this.lastName){
        isFullNameSelected = true;
        lastNameParam=this.lastName
      }

      let isEmailAddressSelected = false;
      let emailAddressParam=null;
      if (this.emailAddress){
        isEmailAddressSelected = true;
        emailAddressParam=this.emailAddress
      }

      let isHashedAddressSelected = false;
      let hashedAddressParam=null;
      if (this.hashedAddress){
        isHashedAddressSelected = true;
        hashedAddressParam=this.hashedAddress
      }

      this.searchParams={
        Page: this.currentPage,
        PageSize: this.recordPerMainPage,
        IsDateAddedSelected: isDateLastVisitedSelected,
        DateAddedDateFrom: lastVisitedDateFrom,
        DateAddedDateTo: lastVisitedDateTo,
        DateDateAddedDynamicType: dateLastVisitedDynamicType,
        IsFullNameSelected: isFullNameSelected,
        FirstName: firstNameParam,
        LastName: lastNameParam,
        IsEmailAddressSelected: isEmailAddressSelected,
        EmailAddress: emailAddressParam,
        IsHashedAddressSelected: isHashedAddressSelected,
        HashedAddress: hashedAddressParam
      }
    },
    // search known customer 
    searchKnownConstomer(){
      this.knownCustomrList=[]
      this.currentPage=1
      this.searchKnownConstomerParam();

      this.$vs.loading();
      this.axios.post("/ws/ConfigExcludeEmailList/SearchKnownCustomers",this.searchParams)
        .then((response) => {
          let data = response.data;
          this.knownCustomrList=data.KnownCustomers?data.KnownCustomers:[]; 
          this.searchKnownCustomerCount(this.searchParams);
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: e.response.data.Errors[0].Message,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            time: 4000,
          });
          this.showError(e);
        });
    },
    //search known customer by page
    searchKnownConstomerPerPage(){
      setTimeout(() => {
        this.searchParams.Page=this.currentPage;
        this.searchParams.PageSize=this.recordPerMainPage;
        if(this.totalKnownCustomer >= 10){
          this.axios.post("/ws/ConfigExcludeEmailList/SearchKnownCustomers",this.searchParams)
            .then((response) => {
              let data = response.data;
              this.knownCustomrList=data.KnownCustomers?data.KnownCustomers:[];  
            })
        }
       }, 1000); 
    },
    // DateLastVisitedDynamicType Value
    checkDateRanges(start,end){
      let selectedStart = start;
      let selectedEnd = end;
      let dateRanges =this.$refs.lastVisitedDynamicType ? this.$refs.lastVisitedDynamicType.$refs.picker.ranges : {};
      if((moment(dateRanges['This month'][0]).format("MM/DD/YYYY") == selectedStart) && moment(dateRanges['This month'][1]).format("MM/DD/YYYY") == selectedEnd){
        return "this month";
      } else if((moment(dateRanges['Last month'][0]).format("MM/DD/YYYY") == selectedStart) && moment(dateRanges['Last month'][1]).format("MM/DD/YYYY") == selectedEnd){
        return "last month";
      } else if(moment(dateRanges['This year'][0]).format("MM/DD/YYYY") == selectedStart && moment(dateRanges['This year'][1]).format("MM/DD/YYYY") == selectedEnd){
        return "this year";
      } else if(moment(dateRanges['Today'][0]).format("MM/DD/YYYY") == selectedStart && moment(dateRanges['Today'][1]).format("MM/DD/YYYY") == selectedEnd){
        return "today";
      } else if(moment(dateRanges['Yesterday'][0]).format("MM/DD/YYYY") == selectedStart && moment(dateRanges['Yesterday'][1]).format("MM/DD/YYYY") == selectedEnd){
        return "yesterday";
      } else {
        return "custom range";
      }
    },
    // Total searched known customr form the search
    searchKnownCustomerCount(searchParams){
      this.axios.post("/ws/ConfigExcludeEmailList/GetSearchKnownCustomerCount",searchParams)
        .then((response)=>{
          let data=response.data;
          this.totalSearchedKnownCustomer=data;
        })
    },
    // Total known customr
    searchKnownCustomerCountTotal(){
      this.axios.get("/ws/ConfigExcludeEmailList/GetTotalKnownCustomers")
        .then((response)=>{
          let data=response.data;
          this.totalKnownCustomer=data;
        })
    },
    addToKnownCustomers(){
      let payload = {
        EmailAddress: this.addeditableKnownCustomerEmail,
        FirstName: this.firstNameKnownCustomer,
        LastName: this.lastNameKnownCustomer
      }

      this.$vs.loading();
        this.axios
            .post("ws/ConfigExcludeEmailList/AppendToKnownCustomers",payload)
            .then(() => {
              this.isPopup = false,
              this.addeditableKnownCustomerEmail = null;
              this.firstNameKnownCustomer = null;
              this.lastNameKnownCustomer = null;
              this.searchKnownConstomer();
              this.searchKnownCustomerCountTotal();
              this.$vs.notify({
                title: "Success",
                text: "Customer added successfully.",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right",
                time: 4000
              });
              this.$vs.loading.close();
            })
            .catch((e) => {
                this.$vs.loading.close();
                this.showError(e);
                this.$vs.notify({
                  title: "Error",
                  text: e.response.data.Errors[0].Message,
                  color: "danger",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  position: "top-right",
                  time: 4000
                });
            });  
    },
    updateKnownCustomers(){
      let payload = {
        KnownCustomerId: this.editableKnownCustomer.KnownCustomerId,
        EmailAddress: this.addeditableKnownCustomerEmail,
        FirstName: this.firstNameKnownCustomer,
        LastName: this.lastNameKnownCustomer,
        DateLastUpdated: this.editableKnownCustomer.DateLastUpdated,
        DateAdded: this.editableKnownCustomer.DateAdded
      }
      this.$vs.loading()
        this.axios.post("/ws/ConfigExcludeEmailList/UpdateKnownCustomer",payload).then(() => {
          this.isPopup = false;
          this.editableKnownCustomer = null;
          this.addeditableKnownCustomerEmail = null;
          this.firstNameKnownCustomer = null;
          this.lastNameKnownCustomer = null;
          this.searchKnownConstomer()
            this.$vs.notify({
                title:'Success',
                text: 'Customer updated successfully.',
                color: "success",
                iconPack: 'feather',
                icon:'icon-check',
                position: "top-right",
                time:4000
            });
            this.$vs.loading.close()
        }).catch(e => {
            this.showError(e);
            this.$vs.notify({
                title:'Error',
                text: e.response.data.Errors[0].Message,
                color: "danger",
                iconPack: 'feather',
                icon:'icon-alert-circle',
                position:"top-right",
                time:4000
            });
        });  
    },
    resetExistingList(){
      this.$vs.loading();
        this.axios
            .get("/ws/ConfigExcludeEmailList/ResetKnownCustomers")
            .then(() => {
              this.resetConfirmPopup = false
              this.searchKnownConstomer();
              this.$vs.notify({
                title: "Success",
                text: "Existing list reset successfully.",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right",
                time: 4000
              });
              this.$vs.loading.close();
            })
            .catch((e) => {
                this.$vs.loading.close();
                this.showError(e);
                this.$vs.notify({
                  title: "Error",
                  text: e.response.data.Errors[0].Message,
                  color: "danger",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  position: "top-right",
                  time: 4000
                });
            });
    },
    deleteSuppression(){
      let payload = []
      for (let i = 0; i < this.selectedMain.length; i++) {
        payload.push(this.selectedMain[i].KnownCustomerId)
      }
      this.$vs.loading()
        this.axios.post("/ws/ConfigExcludeEmailList/DeleteKnownCustomers",payload).then(() => {
            this.searchKnownConstomer()
            this.searchKnownCustomerCountTotal();
            this.deleteConfirmPopup = false;
            this.isPopup = false;
            this.selectedMain = [];
            this.$vs.notify({
                title:'Success',
                text: 'Email deleted successfully.',
                color: "success",
                iconPack: 'feather',
                icon:'icon-check',
                position: "top-right",
                time:4000
            });
            this.$vs.loading.close()
        }).catch(e => {
            this.showError(e);
            this.$vs.notify({
                title:'Error',
                text: e.response.data.Errors[0].Message,
                color: "danger",
                iconPack: 'feather',
                icon:'icon-alert-circle',
                position:"top-right",
                time:4000
            });
        });
    },

    cancelUploadEmailList(){
        this.$refs.file.value = "";
        this.isUploadPopup = false;
        this.isOverwriteExistingListPopup = false;
        this.overwriteExistingList = false;
        this.csv = null;
        this.isImportButton = false;
        this.csvFileName = null;
        this.csvFileErrorMessage = null;
        this.csvUploadRecords = [];
    },
    // Load CSv File
    loadCSV(e) {
      if (this.$refs.file.files[0].type == "text/csv" || this.$refs.file.files[0].type == "application/vnd.ms-excel") {
        this.isImportButton = true;
        this.csvFileName = this.$refs.file.files[0].name;
        this.csvFileErrorMessage = null;
      } else {
        this.csvFileErrorMessage = "Please upload CSV file only.";
        this.terminateRecordUpload();
        return false;
      }
      var vm = this;
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsText(e.target.files[0]);
        reader.onload = function (event) {
          var csv = event.target.result;
          vm.csv = vm.csvJSON(csv);
        };
      } else {
        alert("File Reader are not supported in this browser!");
      }
    },
    terminateRecordUpload(){
      this.isImportButton = false;
      this.$refs.file.value = "";
      this.csvFileName = null;
    },
    csvJSON(csv){
      var lines;
      if(csv.includes("\r\n")){
        lines = csv.split("\r\n");
      } else {
        lines = csv.split("\n");
      }
      var result = [];
      var headers = lines[0].split(",");

      var headerOneId;
      var headerTwoId;
      var headerThreeId;
      var headerNew = [];

      for (let i = 0; i < headers.length; i++) {
        if(headers[i].toLowerCase().trim() === 'emailaddress'){
          headerNew.push(headers[i]);
          headerOneId = i;
        }
        if(headers[i].toLowerCase().trim() === 'firstname'){
          headerNew.push(headers[i]);
          headerTwoId = i;
        }
        if(headers[i].toLowerCase().trim() === 'lastname'){
          headerNew.push(headers[i]);
          headerThreeId = i;
        } 
      }
      if(headerNew.length != 3 || headers[headerOneId].toLowerCase().trim() != 'emailaddress' || headers[headerTwoId].toLowerCase().trim() != 'firstname' || headers[headerThreeId].toLowerCase().trim() != 'lastname'){
        this.csvFileErrorMessage = "Invalid file headers found.  Please use the following headers: EmailAddress, FirstName, LastName"
        this.terminateRecordUpload();
        return false;
      }

      if(lines.length > 100002){
        this.csvFileErrorMessage = "You can upload maximum 100,000 records at a time."
        this.terminateRecordUpload();
        return false;
      }

      lines.map(function (line, indexLine) {
          if (indexLine < 1) return;

          var obj = {};
          var currentline = line.split(",");

          headers.map(function (header, indexHeader) {
            if(headerOneId == indexHeader){
              let finalHeader = headers[indexHeader].toLowerCase().trim() === 'emailaddress' ? 'EmailAddress' : headers[indexHeader].toLowerCase().trim() === 'firstname' ? 'FirstName' : 'LastName' 
              obj[finalHeader] = currentline[indexHeader];
            }
            if(headerTwoId == indexHeader){
              let finalHeader = headers[indexHeader].toLowerCase().trim() === 'emailaddress' ? 'EmailAddress' : headers[indexHeader].toLowerCase().trim() === 'firstname' ? 'FirstName' : 'LastName' 
              obj[finalHeader] = currentline[indexHeader];
            }
            if(headerThreeId == indexHeader){
              let finalHeader = headers[indexHeader].toLowerCase().trim() === 'emailaddress' ? 'EmailAddress' : headers[indexHeader].toLowerCase().trim() === 'firstname' ? 'FirstName' : 'LastName' 
              obj[finalHeader] = currentline[indexHeader];
            }
          });

          result.push(obj);
      });
      // result.pop();
      this.csvUploadRecords = result;
    },
    uploadEmailList(){
      let payload={
        OverwriteList: this.overwriteExistingList,
        KnownCustomers: this.csvUploadRecords
      }
      this.$vs.loading()
        this.axios.post("/ws/ConfigExcludeEmailList/UploadKnownCustomers", payload).then(() => {
            this.searchKnownConstomer()
            this.cancelUploadEmailList();
            this.searchKnownCustomerCountTotal();
            this.$vs.notify({
                title:'Success',
                text: 'Email list uploaded successfully.',
                color: "success",
                iconPack: 'feather',
                icon:'icon-check',
                position: "top-right",
                time:4000
            });
            this.$vs.loading.close()
        }).catch(e => {
            this.showError(e);
            this.$vs.notify({
                title:'Error',
                text: e.response.data.Errors[0].Message,
                color: "danger",
                iconPack: 'feather',
                icon:'icon-alert-circle',
                position:"top-right",
                time:4000
            });
        });  
    }
  },
};
</script>